import script from "./OperatorUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorUpsert.vue?vue&type=style&index=0&id=1c40678a&lang=scss"

const __exports__ = script;

export default __exports__